import React from 'react';
import { useTitle } from '../../../utils/useTitle';
import { SurveyFinishPageContent } from './components/SurveyFinishPageContent';
import { useSurveyRedirect } from './hooks/useSurveyRedirect';

export const SurveyFinishPage = (): JSX.Element => {
  useTitle(['Student Survey']);
  useSurveyRedirect();

  return <SurveyFinishPageContent />;
};
